module.exports = __webpack_public_path__ + "img/plantdetail.5b2256a7.svg";